import { render, staticRenderFns } from "./PlanejamentoAcaoDados.vue?vue&type=template&id=712211d7"
import script from "./PlanejamentoAcaoDados.vue?vue&type=script&lang=js"
export * from "./PlanejamentoAcaoDados.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports